<template>
  <v-list-item v-if="canShow(item)" :href="href" :to="item.to" exact class="px-2 py-1">
    <template #default="{isActive}">
    <v-sheet rounded="xl" class="d-flex align-center pa-2 w-100" :class="(isActive) ? 'active-list-item' : 'bg-transparent'">
      <!-- icon -->
      <v-avatar color="white" size="42" style="border-radius: 16px;" class="mr-3">
        <template v-if="item.icon">
          <component v-if="item.icon.includes('Ph')" :is="item.icon" size="24" />
          <v-icon v-else :icon="item.icon" />
        </template>
      </v-avatar>
      <div class="sm-semi-bold text-primary text-truncate">
        {{ item.title }}
      </div>
    </v-sheet>
    </template>
  </v-list-item>
</template>

<script>
import {useAbility} from "@casl/vue";
import { PhLayout, PhAddressBook, PhUserSwitch, PhSlidersHorizontal, PhCalendarBlank, PhFileText, PhBooks, PhLifebuoy, PhBriefcase, PhTreeView } from "@phosphor-icons/vue";

export default {
  name: "BaseItem",
  components: { PhLayout, PhAddressBook, PhUserSwitch, PhSlidersHorizontal, PhCalendarBlank, PhFileText, PhBooks, PhLifebuoy, PhBriefcase, PhTreeView },
  setup() {
    const { can } = useAbility();
    return {
      can
    };
  },
  props: {
    item: {
      type: Object,
      default: () => ({
        href: undefined,
        icon: undefined,
        title: undefined,
        to: undefined,
      }),
    },
    text: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    canShow(item) {
      //OTHER CHECKS
      if(item.gate.subject === 'home') {
        return true;
      }
      else if(typeof(item.gate.subject) === 'string') {
        return this.can("show", this.$createEntity(item.gate.subject.toLowerCase(), { id: 0 }));
      }
      else {
        return false;
      }
    },
  },
  computed: {
    href() {
      return this.item.href || (!this.item.to ? "#" : undefined);
    },
  },
};
</script>

<style scoped>
:deep(.v-list-item__overlay) {
  opacity: 0 !important;
}
.active-list-item {
  background-color: rgba(var(--v-theme-primary), 0.3) !important;
}
</style>